import { render, staticRenderFns } from "./suggestInput.vue?vue&type=template&id=04d00dfd&scoped=true"
import script from "./suggestInput.vue?vue&type=script&lang=js"
export * from "./suggestInput.vue?vue&type=script&lang=js"
import style0 from "./suggestInput.vue?vue&type=style&index=0&id=04d00dfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d00dfd",
  null
  
)

export default component.exports